/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */
import * as styles from '../styles/Spinner.module.scss';
import {TEST_IDS} from 'src/testing/TestIds';

export type SpinnerProps = {
  className?: string;
};
/** A simple spinner component for showing loading states. */
export const Spinner = ({className = ''}: SpinnerProps) => {
  return (
    <div
      className={`${styles.spinner} ${className}`}
      data-testid={TEST_IDS.Spinner.Container}>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
      <div className={styles.spinnerBlade}></div>
    </div>
  );
};
